// src/helpers/cx.ts
import { cx as classix } from "classix";
import { twMerge } from "tailwind-merge";
var cx = (...argumentList) => twMerge(classix(...argumentList));

export {
  cx
};
